import { render, staticRenderFns } from "./ManageTwofa.vue?vue&type=template&id=2138334d&"
import script from "./ManageTwofa.vue?vue&type=script&lang=js&"
export * from "./ManageTwofa.vue?vue&type=script&lang=js&"
import style0 from "./ManageTwofa.vue?vue&type=style&index=0&id=2138334d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports